import React from 'react';
import { AboutHero } from '../components/AboutHero';
import { OurStory } from '../components/OurStory';
import { VisionaryLeader } from '../components/VisionaryLeader';
import { MissionVision } from '../components/MissionVision';
import { TeamSection } from '../components/TeamSection';
import { AboutCTA } from '../components/AboutCTA';
import { Footer } from '../components/Footer';
export function AboutPage() {
  return <main className="min-h-screen bg-white" data-id="element-274">
      <AboutHero data-id="element-275" />
      <OurStory data-id="element-276" />
      <VisionaryLeader data-id="element-277" />
      <MissionVision data-id="element-278" />
      <TeamSection data-id="element-279" />
      <AboutCTA data-id="element-280" />
      <Footer data-id="element-281" />
    </main>;
}